import { render, staticRenderFns } from "./CompItem.vue?vue&type=template&id=fa632952&"
import script from "./CompItem.vue?vue&type=script&lang=js&"
export * from "./CompItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports